import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import AuthService from "../services/auth.service";

const BeltClassNewApp = React.lazy(() => import('../classAppComponents/BeltClassNewApp'));
const AddClass = React.lazy(() => import('../classAppForms/AddClass'));

class PageClassAdd extends React.Component {

  state = {
    currentUser: AuthService.getCurrentUser(),
    data: [],
    currentPage: "1",
    rowsCount: "25",
    title: "RezerwujKort.pl - Szkółki tenisowe"
  }

  componentDidMount() {
    document.title = this.state.title;
    //console.log("this.props.match.params.dayofweekwwwwwwwww " + JSON.stringify(this.props.match.params.dayofweek)); //usun
    var url = "/rest/class_app/" + this.props.match.params.club + "/admin/admins";
    if (this.props.match.params.page != null) {
      url = url + "/" + this.props.match.params.page + "/" + this.state.rowsCount;
      this.setState({ currentPage: this.props.match.params.page });
    }

    fetch(url, {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': 'Bearer ' + this.state.currentUser.accessToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ data });
      })

    fetch("/class_app/" + this.props.match.params.club + "/admin/admins/count", {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': 'Bearer ' + this.state.currentUser.accessToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(adminsCount => {
        //console.log("adminsCount " + adminsCount);
        this.setState({ adminsCount });
      })

  }

  render() {

    var msg = this.props.location.state;
    var button = "";
    if (msg === undefined) {
      button = "";
    } else {
      button = <div class="tenis-center-content-info">+  {msg}  + </div>;
    }

    var beltClassApp = <div>
      <Suspense fallback={<div>
        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
      </div>}>
        <BeltClassNewApp club={this.props.match.params.club} />
      </Suspense>
    </div>

    var addClass = <div>
      <Suspense fallback={<div>
        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
      </div>}>
        <AddClass id={this.props.match.params.id}
          club={this.props.match.params.club} />
      </Suspense>
    </div>

    return (

      <div>
        {beltClassApp}

        <div id="content">
          <div class="container">

            

            <br /><br />

            {button}

            <br /><br />
            <b>Dodaj nową szkółkę </b>
            <br /><br />

            {addClass}

          </div>
        </div>


      </div>
    );
  }
}
export default PageClassAdd;
